import { mixpanel } from '@fiverr-private/obs';
import { getDataFromStores } from '../../../utils';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import type { FAQClickedInput, FAQClickedStore } from './types';

/**
 * The user clicked on one of FAQs
 */
export const createReportFAQClicked =
    (store: FAQClickedStore) =>
    ({ question }: FAQClickedInput): void => {
        const payload = {
            ...getDataFromStores(
                store.user,
                store.referrer,
                store.fromBoost,
                store.pageType,
                store.pagePath
            ),
            [MIXPANEL_EVENT_PROPERTIES.QUESTION_CLICKED]: question,
        };

        mixpanel.track('Logo Maker - Landing Page - FAQ clicked', payload);
    };
